module.exports = function () {
const holidayLogo = `/demo/partials/criticalcss/holiday-logo.css`;
return (`
<style><!--# include virtual="${holidayLogo}" --></style>
`)
};
